import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import LandingPage from './Components/LandingPage';
import Login from './Components/Login';
import Register from './Components/Register';
import Employee from './Components/Employee';
import EmployeeProjects from './Components/EmployeeProjects';
import Admin from './Components/Admin';
import History from './Components/History';
import ProtectedRoute from './Components/ProtectedRoute';
import MainManager from './Components/MainManager';
import LeadDashboard from './Components/LeadDashboard';
import ResetPassword from './Components/ResetPassword';
import { ThemeProvider } from './Components/ThemeContext';
import { ToastProvider } from './Components/ToastContext';
import { ConfirmDialogProvider } from './Components/ConfirmDialog';
import ToastContainer from './Components/ToastContainer';

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <ConfirmDialogProvider>
          <BrowserRouter>
            <Routes>
              <Route exact path="/" element={<LandingPage />} />
              <Route exact path="/login" element={<Login />} />
              <Route exact path="/register" element={<Register />} />
              <Route exact path="/employee-projects" element={
                <ProtectedRoute><EmployeeProjects /></ProtectedRoute>} />
              <Route exact path="/employee" element={
                <ProtectedRoute><Employee /></ProtectedRoute>} />
              <Route exact path="/history" element={
                <ProtectedRoute><History /></ProtectedRoute>} />
              <Route exact path="/admin" element={
                <ProtectedRoute><Admin /></ProtectedRoute>} />
              <Route exact path="/main-manager" element={
                <ProtectedRoute><MainManager /></ProtectedRoute>} />
              <Route exact path="/lead-dashboard" element={
                <ProtectedRoute><LeadDashboard /></ProtectedRoute>} />
              <Route exact path="/reset-password" element={<ResetPassword />} />
            </Routes>
          </BrowserRouter>
          {/* Toast container lives at root so it's always available */}
          <ToastContainer />
        </ConfirmDialogProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
